import React from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';

import Page from 'src/shared/ui/components/Page';
import PaymentForm from 'src/payment/ui/components/PaymentForm';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  saveButton: {
    top: '-20px'
  },
  backButton: {
    top: '-20px',
    marginRight: theme.spacing(1)
  },
  scrollBox: {
    overflow: 'scroll',
    height: '80vh'
  }
}));

const PaymentFormView = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate('/app/payments');
  };

  return (
    <Page className={classes.root} title="Pago">
      <PaymentForm cancel={handleCancel} />
    </Page>
  );
};

export default PaymentFormView;
